/* eslint-disable max-len */
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavigationTabToolbarPropTypes } from '../../types/propTypes/NavigationTabToolbarPropTypes';
import './NavigationTabToolbar.css';

const NavigationTabToolbar = ({
  navigationTabs,
  ariaLabel,
}: NavigationTabToolbarPropTypes): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();

  const locationPathname = location.pathname.toLowerCase();
  const matchingTabRoutePathIndex = navigationTabs.findIndex((x) => {
    const tabRoutePath = x.routePath.toLowerCase();
    // Handle parameterized routes by checking if the location path starts with the base route
    const baseRoute = tabRoutePath.replace(/:[^/]+/g, '');
    return locationPathname.startsWith(baseRoute);
  });
  const selectedTabIndex =
    matchingTabRoutePathIndex >= 0 ? matchingTabRoutePathIndex : 0;

  const handleChange = (
    event: React.SyntheticEvent,
    newTabIndex: number
  ): void => {
    /* istanbul ignore next */
    if (navigationTabs.length > newTabIndex) {
      navigate(navigationTabs[newTabIndex].routePath);
    }
  };

  return (
    <div>
      <div>
        <Tabs
          value={selectedTabIndex}
          onChange={handleChange}
          scrollButtons="auto"
          aria-label={ariaLabel}
          sx={{
            overflow: 'visible !important', // Ensure Tabs itself doesn't have hidden overflow
            '& .MuiTabs-scroller': {
              overflow: 'visible !important',
              width: 'auto !important', // Use auto to allow natural width expansion
            },
            '& .MuiTabs-flexContainer': {
              width: 'auto !important', // Ensure flex container expands
            },
          }}
        >
          {navigationTabs.map((tab, index) => (
            <Tab
              key={`tab-text-${index}`}
              className="tab-text"
              label={tab.name}
              id={`tab-${index}`}
            />
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default NavigationTabToolbar;
